import {timeago, fullTime, shortDate} from './filters/date';
import { getFileUrl } from './filters/url';
import { getDevice, getExternalUrl } from './filters/cpd';
import { comma, short } from './filters/number';

export default {
  install(app) {
    app.config.globalProperties.$filters = {
      icon(value){
        if (value == 'Email') return 'far fa-envelope';
        if (value == 'Youtube') return 'fab fa-youtube';
        if (value == 'Github') return 'fab fa-github';
      },
      shortDate,
      fullTime,
      timeago,
      getFileUrl,
      getDevice,
      getExternalUrl,
      comma,
      short
    }
  }
};
